import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getProfile } from "../../api/user";
import secureStorage from "../../utils/secureStorage";
import { useTheme } from "../../context/ThemeContext";

const VerificationSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();

  useEffect(() => {
    // Redirect to home after 2 seconds
    const timer = setTimeout(async () => {
      const response = await getProfile();
      if (response && response.data.success && response.data.data) {
        const user = response.data.data;
        secureStorage.setJSON("user", user);
        navigate("/");
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white dark:bg-[#0A0C1C]">
      <h2 className="text-[#6d29f6] dark:text-white text-xl font-bold mt-8 mb-4">VIBELINKS</h2>
      <svg width="160" height="160" viewBox="0 0 160 160" fill="none">
        <circle cx="80" cy="80" r="70" stroke="#6d29f6" strokeWidth="12" />
        <path
          d="M55 85L75 105L110 70"
          stroke="#6d29f6"
          strokeWidth="12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h1 className="text-[#6d29f6] dark:text-white text-3xl font-bold mt-8">
        {t("you_re_in")}
      </h1>
    </div>
  );
};

export default VerificationSuccess;
